import { render, staticRenderFns } from "./ChargebackRideDialog.vue?vue&type=template&id=555cd6a8&"
import script from "./ChargebackRideDialog.vue?vue&type=script&lang=js&"
export * from "./ChargebackRideDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports